import React, { useState } from 'react';
import './Calendar.css';

interface CalendarProps {
  currentDate: Date;
  onDateSelect: (date: Date) => void;
  onClose: () => void;
}

export const Calendar = ({ currentDate, onDateSelect, onClose }: CalendarProps) => {
  const [viewDate, setViewDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));

  const changeMonth = (amount: number) => {
    setViewDate(prev => new Date(prev.getFullYear(), prev.getMonth() + amount, 1));
  };

  const renderDays = () => {
    const year = viewDate.getFullYear();
    const month = viewDate.getMonth();
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const days = [];
    // Add blank cells for days before the 1st
    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    }

    // Add the days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const thisDate = new Date(year, month, day);
      const isSelected = thisDate.toDateString() === currentDate.toDateString();
      
      const classNames = `calendar-day ${isSelected ? 'selected' : ''}`;

      days.push(
        <button 
          key={day} 
          className={classNames}
          onClick={() => onDateSelect(thisDate)}
        >
          {day}
        </button>
      );
    }
    return days;
  };

  const monthName = viewDate.toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    <div className="calendar-backdrop" onClick={onClose}>
      <div className="calendar-modal" onClick={e => e.stopPropagation()}>
        <div className="calendar-header">
          <button onClick={() => changeMonth(-1)}>‹</button>
          <h2>{monthName}</h2>
          <button onClick={() => changeMonth(1)}>›</button>
        </div>
        <div className="calendar-weekdays">
          <div>Sun</div><div>Mon</div><div>Tue</div><div>Wed</div><div>Thu</div><div>Fri</div><div>Sat</div>
        </div>
        <div className="calendar-grid">
          {renderDays()}
        </div>
      </div>
    </div>
  );
};